module.exports = __webpack_public_path__ + "img/marker_four_green1.3d28e65c.png";